import { isLauncherJourney } from '@epilot/journey-logic-commons/src/next/journey'

import { selectJourney } from '../selectors/config'
import { selectBlocksMapCache } from '../selectors/runtime'
import type { BlockValues } from '../types'
import type { SyncStepsStateAction } from '../types/actions'

import { actionFactory } from './factory'

export const syncStepsState = actionFactory<SyncStepsStateAction>(
  (state, { stepsState }) => {
    const journey = selectJourney(state)

    if (!journey) {
      throw new Error('Expected a Journey to be selected')
    }

    if (isLauncherJourney(journey)) {
      // mostly to coerce TS, should never happen
      throw new Error('Implementation error, launcher journeys have no state')
    }

    const blocksMapCache = selectBlocksMapCache(state)

    if (!blocksMapCache) {
      throw new Error('Expected a blocksMap to be set')
    }

    state.blockValues = stepsState.reduce<BlockValues>(
      (acc, stepState, stepIndex) => {
        for (const [blockName, value] of Object.entries(stepState)) {
          const block = blocksMapCache.get(stepIndex)?.get(blockName)

          if (block) {
            acc[block.id] = value
          }
        }

        return acc
      },
      {}
    )
  },
  'syncStepsState'
)
